import React, { useEffect, useRef, useState } from "react";
import Header from "../Sections/Career/Header/Header";
import Banner from "../Sections/Career/Banner/Banner";
import FreeApp from "../Sections/Download/FreeApp";
import Choose from "../Sections/Career/Zowo/Choose";
import CareerOpenings from "../Sections/Career/Openings/CareerOpenings";
import Zowo from "../Sections/Career/Choose/Zowo";
import Footer from "../Footer/Footer";

const Career = () => {
  return (
    <>
      <Header></Header>
      <Banner></Banner>
      <Zowo></Zowo>
      <CareerOpenings></CareerOpenings>
      {/* <Choose></Choose> */}
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Career;
